import entityReducer from "./employeeEntityReducer";

const reducers = { entities: entityReducer };

export default reducers;
